export default __webpack_public_path__ + "static/media/arrow-point-to-right.e9b72d06.png";